// extracted by mini-css-extract-plugin
export default {"navigation":"NavFooter_navigation__KpIJa","navText":"NavFooter_navText__XWypt"};